import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { exportModalDataAtom } from '@/atoms/exporting';
import { ExportContent, ExportModalProps } from '@/types/exporting';
import { MenuItemWithIcon } from '../menu/MenuItemWithIcon';
import { MoreOptionsMenu } from '../menu/MoreOptionsMenu/MoreOptionsMenu';

interface VisualisationMenuProps {
  exportModalProps: ExportModalProps;
  children?: JSX.Element;
  keysToExcludeFromClose?: string[];
}

export const VisualisationMenu = ({
  exportModalProps: { visName, templateName, secondaryTitlePrefix, customWidth },
  keysToExcludeFromClose,
  children,
}: VisualisationMenuProps) => {
  const { t } = useTranslation('export');
  const setExportModalData = useSetAtom(exportModalDataAtom);

  return (
    <MoreOptionsMenu keysToExcludeFromClose={keysToExcludeFromClose}>
      <MenuItemWithIcon
        onClick={() => {
          setExportModalData({
            visName,
            templateName,
            secondaryTitlePrefix,
            customWidth,
            content: ExportContent.VIS,
          });
        }}
        icon="Download"
        text={t('export')}
      />
      {children}
    </MoreOptionsMenu>
  );
};
